import { action, makeObservable, ObservableMap } from 'mobx';

const STORAGE_KEY_VISIBILITY = 'timelog:calendar:visibility';

export class CalendarVisibilityModel {
  private _visibility: ObservableMap<string, boolean> = new ObservableMap();

  constructor() {
    this._loadFromStorage();

    makeObservable<CalendarVisibilityModel, '_visibility'>(this, {
      _visibility: true,
      toggle: action.bound,
    });
  }

  isVisible(calendarId: string): boolean {
    return this._visibility.get(calendarId) ?? true;
  }

  toggle(calendarId: string): void {
    const current = this.isVisible(calendarId);
    this._visibility.set(calendarId, !current);
    this._saveToStorage();
  }

  private _loadFromStorage(): void {
    try {
      const stored = localStorage.getItem(STORAGE_KEY_VISIBILITY);

      if (!stored) return;

      const parsed = JSON.parse(stored) as Record<string, boolean>;

      for (const [id, visible] of Object.entries(parsed)) {
        if (typeof visible === 'boolean') {
          this._visibility.set(id, visible);
        }
      }
    } catch {
      // Ignore invalid data
    }
  }

  private _saveToStorage(): void {
    try {
      const obj: Record<string, boolean> = {};

      for (const [id, visible] of this._visibility.entries()) {
        obj[id] = visible;
      }

      localStorage.setItem(STORAGE_KEY_VISIBILITY, JSON.stringify(obj));
    } catch {
      // Ignore write errors
    }
  }
}
